import { render, staticRenderFns } from "./Sjly.vue?vue&type=template&id=56bf4a19&scoped=true"
var script = {}
import style0 from "./Sjly.vue?vue&type=style&index=0&id=56bf4a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf4a19",
  null
  
)

export default component.exports